import axios from 'axios';
import { FETCH_PRODUCTS, CREATE_PRODUCT, DELETE_PRODUCT } from '../types';
import { notification } from '../../utils';

export const fetchProducts = () => async (dispatch) => {
  try {
    const allProducts = await axios.get('/api/products/');
    const getProducts = await allProducts.data;
    dispatch({
      type: FETCH_PRODUCTS,
      payload: getProducts,
    });
  } catch (error) {
    notification('error', 'An error occured!');
  }
};

export const fetchSingleProduct = async (id) => {
  try {
    const product = await axios.get(`/api/products/${id}`);
    const getProduct = await product.data;
    return getProduct;
  } catch (error) {
    notification('error', 'An error occured!');
  }
};

export const createProduct =
  (product, setIsSubmitted) => async (dispatch, getState) => {
    const { items } = getState().products;

    try {
      const createProduct = await axios.post('/api/products', product);
      const createdProduct = createProduct.data;

      const allProducts = items.slice();
      allProducts.push(createdProduct);
      notification('success', 'product created!');
      dispatch({ type: CREATE_PRODUCT, payload: allProducts });
      setIsSubmitted(true);
    } catch (error) {
      notification('error', 'An error occured!');
    }
  };

export const deleteProduct = (id) => async (dispatch, getState) => {
  const {
    products: { items },
  } = getState();

  try {
    const deletedProduct = await axios.delete(`/api/products/${id}`);
    const deletedItem = deletedProduct.data;

    dispatch({
      type: DELETE_PRODUCT,
      payload: items.slice().filter((i) => i._id !== deletedItem._id),
    });
    notification('success', `Product deleted!`);
  } catch (err) {
    notification('error', 'An error occured!');
  }
};
